import { MealyModelType } from '../mealyModelType';
import CodeschlossSystem from './CodeschlossSystem.svelte';
export const mealyModelCodeschloss = {
    component: CodeschlossSystem,
    type: MealyModelType.CODESCHLOSS,
    alphabet: ['1', '2', '3', '4', 'öffnen'],
    outputs: ['nichts', 'Tür_öffnen'],
};
